/**
 * @author Sumit Majumdar
 * @email sumit@grexit.com
 * @create date 2018-04-02 02:13:40
 * @modify date 2018-04-02 02:13:40
 * @desc [description]
*/
import { UPDATE_SM_DONE, UPDATE_SM_INIT, UPDATE_SM_FAILED } from '../../common/actions';
import { getSmEmailId } from '../../common/utils';
import { HiverAxios, unsavedChanges, showMessage } from 'h-commons';
const SM_ROOT = '/gx/api/sm';

/** 
 * Transforms sharedmailbox data to format compatible with advanced setting API
 * @param {Object} sharedmailbox - object representing one shared mailbox
*/
const transformData = ({ display_name, target_emails = [], isgagroup, ...rest }) => ({
    source_email: getSmEmailId(rest, isgagroup),
    display_name: encodeURIComponent(display_name),
    target_emails: target_emails.map(({ email }) => email),
    is_gagroup: isgagroup
});

/**
 * @param  {(number|string)} smid   - shared mailbox id 
 * @param  {Object}          data   - updation data
 * @param  {boolean}         isTest - for unit tests
 */
export const updateSMAction = (smid, data, isTest) => dispatch => {
    dispatch({
        type: UPDATE_SM_INIT
    });
    return HiverAxios({
        url: `${SM_ROOT}/${smid}`,
        type: 'PUT',
        params: transformData(data),
        callback: (response) => {
            dispatch(unsavedChanges(false));
            const success = response.data.status === 'success';
            if (success) {
                dispatch({
                    type: UPDATE_SM_DONE,
                    payload: response.data.sm
                });
                showMessage({
                    message: 'Shared Mailbox name updated',
                    type: 'success'
                });
            } else {
                dispatch({
                    type: UPDATE_SM_FAILED
                });
                showMessage({
                    message: 'Shared Mailbox name updation failed',
                    type: 'error'
                });
            }

        },
        onfail: (err) => {
            const message = err.response && err.response.data && err.response.data.message
                ? err.response.data.message : 'Failed to update Shared mailbox';
            dispatch({
                type: UPDATE_SM_FAILED
            });
            showMessage({
                message: 'Failed to update Name',
                type: 'error'
            });
        }
    }, isTest);
}

